import VirtualCanvas from '@fusioncharts/charts/src/_internal/components/canvases/vcanvas';
import { componentFactory } from '@fusioncharts/core/src/lib';
/**
 * Function to create virtual canvas, additionally axis data is added to the env of virtual canvas
 */
export default function (chart) {
  let canvas = chart.getChildren('canvas')[0],
    axisSelectorUI = chart.getChildren('yAxisSelectorUI'), // eslint-disable-line good-practices/no-single-usage-variable
    axisY = chart.getFromEnv('dataSource').axis, // eslint-disable-line good-practices/no-single-usage-variable
    vCanvas,
    axes,
    xAxis = [],
    yAxis = [],
    vC,
    i,
    k,
    j;

  axes = chart.getChildren('xAxis');
  for (k = 0; k < (axes && axes.length); k++) {
    if (!axes[k].getState('removed')) {
      xAxis.push(axes[k]);
    }
  }
  axisSelectorUI.forEach(comp => {
    axes = comp.getChildren('yAxis');
    for (k = 0; k < (axes && axes.length); k++) {
      if (!axes[k].getState('removed')) {
        yAxis.push(axes[k]);
      }
    }
  });

  componentFactory(canvas, VirtualCanvas, 'vCanvas', xAxis.length * yAxis.length);
  vCanvas = canvas.getChildren('vCanvas');
  for (i = 0, k = 0; i < (xAxis && xAxis.length); i++) {
    for (j = 0; j < (yAxis && yAxis.length); j++, k++) {
      vC = vCanvas[k];
      vC.configure();
      vC.xAxis(xAxis[i])
        .yAxis(yAxis[j])
        .canvas(canvas);
      vC.addToEnv('axisData', axisY[k]);
      vC.addToEnv('vCanvas', vCanvas[k]);
    }
  }
}
